import { IRetryPolicy } from '@microsoft/signalr';

export class RetryPolicy implements IRetryPolicy {
  nextRetryDelayInMilliseconds(): number | null {
    return 5000;
  }
}
